module.exports = __webpack_public_path__ + "img/application_icon_fly_inactive.2dbf11ac.png";